
/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  FreelancerVerificationDetailsResource,
  FreelancerVerificationStatus,
  FreelancersWorkforceListV2Resource,
  SortDirection,
  WorkforceProjectsListResource,
  WorkforceProjectsSummaryResource,
  WorkforceSortField,
} from '../models';
import {
    FreelancerVerificationDetailsResourceFromJSON,
    FreelancerVerificationDetailsResourceToJSON,
    FreelancerVerificationStatusFromJSON,
    FreelancerVerificationStatusToJSON,
    FreelancersWorkforceListV2ResourceFromJSON,
    FreelancersWorkforceListV2ResourceToJSON,
    SortDirectionFromJSON,
    SortDirectionToJSON,
    WorkforceProjectsListResourceFromJSON,
    WorkforceProjectsListResourceToJSON,
    WorkforceProjectsSummaryResourceFromJSON,
    WorkforceProjectsSummaryResourceToJSON,
    WorkforceSortFieldFromJSON,
    WorkforceSortFieldToJSON,
} from '../models';

export interface CheckFreelancersWorkforceAccessAllowedRequest {
    clientTeamId: string;
}

export interface DownloadFreelancersDocumentsAsZipRequest {
    organizationId: string;
    freelancerIds: Array<string>;
}

export interface DownloadProjectDocumentsAsZipRequest {
    confirmedProjectId: string;
    organizationId: string;
    freelancerCompanyId: string;
}

export interface ExportFreelancersWorkforceV2Request {
    organizationId: string;
    clientTeamIds: Array<string>;
    query: string;
    startDate?: Date;
    endDate?: Date;
    thresholdIds?: Array<string>;
    sortField?: WorkforceSortField;
    sortDirection?: SortDirection;
    hasActiveProject?: boolean;
    verificationStatus?: FreelancerVerificationStatus;
    countryCodes?: Array<string>;
}

export interface GetFreelancerProjectsRequest {
    organizationId: string;
    freelancerCompanyId: string;
    page?: number;
    size?: number;
}

export interface GetFreelancerProjectsSummaryRequest {
    organizationId: string;
    freelancerCompanyId: string;
}

export interface GetFreelancerVerificationDetailsRequest {
    organizationId: string;
    freelancerCompanyId: string;
}

export interface GetFreelancersWorkforceV2Request {
    organizationId: string;
    clientTeamIds: Array<string>;
    page: number;
    pageSize: number;
    query: string;
    startDate?: Date;
    endDate?: Date;
    thresholdIds?: Array<string>;
    sortField?: WorkforceSortField;
    sortDirection?: SortDirection;
    verificationStatus?: FreelancerVerificationStatus;
    countryCodes?: Array<string>;
}

/**
 * 
 */
export class FreelancerWorkforceApi extends runtime.BaseAPI {

    /**
     * Check if company has access to freelancers workforce
          */
    async checkFreelancersWorkforceAccessAllowedRaw(requestParameters: CheckFreelancersWorkforceAccessAllowedRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<boolean>> {
        if (requestParameters['clientTeamId'] == null) {
            throw new runtime.RequiredError(
                'clientTeamId',
                'Required parameter "clientTeamId" was null or undefined when calling checkFreelancersWorkforceAccessAllowed().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<boolean>({
            path: `/compliance/api/freelancers/workforce/is-access-allowed/{clientTeamId}`.replace(`{${"clientTeamId"}}`, encodeURIComponent(String(requestParameters['clientTeamId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
     * Check if company has access to freelancers workforce
          */
    async checkFreelancersWorkforceAccessAllowed(requestParameters: CheckFreelancersWorkforceAccessAllowedRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.checkFreelancersWorkforceAccessAllowedRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * download all legal documents of freelancers
          */
    async downloadFreelancersDocumentsAsZipRaw(requestParameters: DownloadFreelancersDocumentsAsZipRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<Blob>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling downloadFreelancersDocumentsAsZip().'
            );
        }

        if (requestParameters['freelancerIds'] == null) {
            throw new runtime.RequiredError(
                'freelancerIds',
                'Required parameter "freelancerIds" was null or undefined when calling downloadFreelancersDocumentsAsZip().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['organizationId'] != null) {
            queryParameters['organizationId'] = requestParameters['organizationId'];
        }

        if (requestParameters['freelancerIds'] != null) {
            queryParameters['freelancerIds'] = requestParameters['freelancerIds']!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<Blob>({
            path: `/compliance/api/freelancers/workforce/documents/download`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
     * download all legal documents of freelancers
          */
    async downloadFreelancersDocumentsAsZip(requestParameters: DownloadFreelancersDocumentsAsZipRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.downloadFreelancersDocumentsAsZipRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * download the available documents (invoices) for a single confirmed project as a zip
          */
    async downloadProjectDocumentsAsZipRaw(requestParameters: DownloadProjectDocumentsAsZipRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<Blob>> {
        if (requestParameters['confirmedProjectId'] == null) {
            throw new runtime.RequiredError(
                'confirmedProjectId',
                'Required parameter "confirmedProjectId" was null or undefined when calling downloadProjectDocumentsAsZip().'
            );
        }

        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling downloadProjectDocumentsAsZip().'
            );
        }

        if (requestParameters['freelancerCompanyId'] == null) {
            throw new runtime.RequiredError(
                'freelancerCompanyId',
                'Required parameter "freelancerCompanyId" was null or undefined when calling downloadProjectDocumentsAsZip().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['organizationId'] != null) {
            queryParameters['organizationId'] = requestParameters['organizationId'];
        }

        if (requestParameters['freelancerCompanyId'] != null) {
            queryParameters['freelancerCompanyId'] = requestParameters['freelancerCompanyId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<Blob>({
            path: `/compliance/api/freelancers/workforce/projects/{confirmedProjectId}/documents`.replace(`{${"confirmedProjectId"}}`, encodeURIComponent(String(requestParameters['confirmedProjectId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
     * download the available documents (invoices) for a single confirmed project as a zip
          */
    async downloadProjectDocumentsAsZip(requestParameters: DownloadProjectDocumentsAsZipRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.downloadProjectDocumentsAsZipRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Export full freelancer workforce data as CSV according to query parameters. Returns all data matching the filters without pagination for CSV download. 
          */
    async exportFreelancersWorkforceV2Raw(requestParameters: ExportFreelancersWorkforceV2Request, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<Blob>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling exportFreelancersWorkforceV2().'
            );
        }

        if (requestParameters['clientTeamIds'] == null) {
            throw new runtime.RequiredError(
                'clientTeamIds',
                'Required parameter "clientTeamIds" was null or undefined when calling exportFreelancersWorkforceV2().'
            );
        }

        if (requestParameters['query'] == null) {
            throw new runtime.RequiredError(
                'query',
                'Required parameter "query" was null or undefined when calling exportFreelancersWorkforceV2().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['clientTeamIds'] != null) {
            queryParameters['clientTeamIds'] = requestParameters['clientTeamIds']!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters['query'] != null) {
            queryParameters['query'] = requestParameters['query'];
        }

        if (requestParameters['startDate'] != null) {
            queryParameters['startDate'] = (requestParameters['startDate'] as any).toISOString();
        }

        if (requestParameters['endDate'] != null) {
            queryParameters['endDate'] = (requestParameters['endDate'] as any).toISOString();
        }

        if (requestParameters['thresholdIds'] != null) {
            queryParameters['thresholdIds'] = requestParameters['thresholdIds']!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters['sortField'] != null) {
            queryParameters['sortField'] = requestParameters['sortField'];
        }

        if (requestParameters['sortDirection'] != null) {
            queryParameters['sortDirection'] = requestParameters['sortDirection'];
        }

        if (requestParameters['hasActiveProject'] != null) {
            queryParameters['hasActiveProject'] = requestParameters['hasActiveProject'];
        }

        if (requestParameters['verificationStatus'] != null) {
            queryParameters['verificationStatus'] = requestParameters['verificationStatus'];
        }

        if (requestParameters['countryCodes'] != null) {
            queryParameters['countryCodes'] = requestParameters['countryCodes']!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<Blob>({
            path: `/compliance/api/freelancers/workforce/{organizationId}/v2/export`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
     * Export full freelancer workforce data as CSV according to query parameters. Returns all data matching the filters without pagination for CSV download. 
          */
    async exportFreelancersWorkforceV2(requestParameters: ExportFreelancersWorkforceV2Request, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.exportFreelancersWorkforceV2Raw(requestParameters, initOverrides);
        return response._data;
    }

    /**
          */
    async getFreelancerProjectsRaw(requestParameters: GetFreelancerProjectsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<WorkforceProjectsListResource>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling getFreelancerProjects().'
            );
        }

        if (requestParameters['freelancerCompanyId'] == null) {
            throw new runtime.RequiredError(
                'freelancerCompanyId',
                'Required parameter "freelancerCompanyId" was null or undefined when calling getFreelancerProjects().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['organizationId'] != null) {
            queryParameters['organizationId'] = requestParameters['organizationId'];
        }

        if (requestParameters['freelancerCompanyId'] != null) {
            queryParameters['freelancerCompanyId'] = requestParameters['freelancerCompanyId'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<WorkforceProjectsListResource>({
            path: `/compliance/api/freelancers/workforce/projects`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=WorkforceProjectsListResourceFromJSON(response._data); }
        return response;
    }

    /**
          */
    async getFreelancerProjects(requestParameters: GetFreelancerProjectsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<WorkforceProjectsListResource> {
        const response = await this.getFreelancerProjectsRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Summary totals (project count, total days worked, total cost) for a freelancer\'s projects within the organization
          */
    async getFreelancerProjectsSummaryRaw(requestParameters: GetFreelancerProjectsSummaryRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<WorkforceProjectsSummaryResource>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling getFreelancerProjectsSummary().'
            );
        }

        if (requestParameters['freelancerCompanyId'] == null) {
            throw new runtime.RequiredError(
                'freelancerCompanyId',
                'Required parameter "freelancerCompanyId" was null or undefined when calling getFreelancerProjectsSummary().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['organizationId'] != null) {
            queryParameters['organizationId'] = requestParameters['organizationId'];
        }

        if (requestParameters['freelancerCompanyId'] != null) {
            queryParameters['freelancerCompanyId'] = requestParameters['freelancerCompanyId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<WorkforceProjectsSummaryResource>({
            path: `/compliance/api/freelancers/workforce/projects/summary`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=WorkforceProjectsSummaryResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Summary totals (project count, total days worked, total cost) for a freelancer\'s projects within the organization
          */
    async getFreelancerProjectsSummary(requestParameters: GetFreelancerProjectsSummaryRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<WorkforceProjectsSummaryResource> {
        const response = await this.getFreelancerProjectsSummaryRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
          */
    async getFreelancerVerificationDetailsRaw(requestParameters: GetFreelancerVerificationDetailsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<FreelancerVerificationDetailsResource>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling getFreelancerVerificationDetails().'
            );
        }

        if (requestParameters['freelancerCompanyId'] == null) {
            throw new runtime.RequiredError(
                'freelancerCompanyId',
                'Required parameter "freelancerCompanyId" was null or undefined when calling getFreelancerVerificationDetails().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['organizationId'] != null) {
            queryParameters['organizationId'] = requestParameters['organizationId'];
        }

        if (requestParameters['freelancerCompanyId'] != null) {
            queryParameters['freelancerCompanyId'] = requestParameters['freelancerCompanyId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<FreelancerVerificationDetailsResource>({
            path: `/compliance/api/freelancers/workforce/verification-details`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=FreelancerVerificationDetailsResourceFromJSON(response._data); }
        return response;
    }

    /**
          */
    async getFreelancerVerificationDetails(requestParameters: GetFreelancerVerificationDetailsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<FreelancerVerificationDetailsResource> {
        const response = await this.getFreelancerVerificationDetailsRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Returns freelancer workforce data according to query parameters. This V2 allows to filter per misclassification threshold and also returns data on misclassification threshold (when applicable). 
          */
    async getFreelancersWorkforceV2Raw(requestParameters: GetFreelancersWorkforceV2Request, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<FreelancersWorkforceListV2Resource>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling getFreelancersWorkforceV2().'
            );
        }

        if (requestParameters['clientTeamIds'] == null) {
            throw new runtime.RequiredError(
                'clientTeamIds',
                'Required parameter "clientTeamIds" was null or undefined when calling getFreelancersWorkforceV2().'
            );
        }

        if (requestParameters['page'] == null) {
            throw new runtime.RequiredError(
                'page',
                'Required parameter "page" was null or undefined when calling getFreelancersWorkforceV2().'
            );
        }

        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling getFreelancersWorkforceV2().'
            );
        }

        if (requestParameters['query'] == null) {
            throw new runtime.RequiredError(
                'query',
                'Required parameter "query" was null or undefined when calling getFreelancersWorkforceV2().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['clientTeamIds'] != null) {
            queryParameters['clientTeamIds'] = requestParameters['clientTeamIds']!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['query'] != null) {
            queryParameters['query'] = requestParameters['query'];
        }

        if (requestParameters['startDate'] != null) {
            queryParameters['startDate'] = (requestParameters['startDate'] as any).toISOString();
        }

        if (requestParameters['endDate'] != null) {
            queryParameters['endDate'] = (requestParameters['endDate'] as any).toISOString();
        }

        if (requestParameters['thresholdIds'] != null) {
            queryParameters['thresholdIds'] = requestParameters['thresholdIds']!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters['sortField'] != null) {
            queryParameters['sortField'] = requestParameters['sortField'];
        }

        if (requestParameters['sortDirection'] != null) {
            queryParameters['sortDirection'] = requestParameters['sortDirection'];
        }

        if (requestParameters['verificationStatus'] != null) {
            queryParameters['verificationStatus'] = requestParameters['verificationStatus'];
        }

        if (requestParameters['countryCodes'] != null) {
            queryParameters['countryCodes'] = requestParameters['countryCodes']!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<FreelancersWorkforceListV2Resource>({
            path: `/compliance/api/freelancers/workforce/{organizationId}/v2`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=FreelancersWorkforceListV2ResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Returns freelancer workforce data according to query parameters. This V2 allows to filter per misclassification threshold and also returns data on misclassification threshold (when applicable). 
          */
    async getFreelancersWorkforceV2(requestParameters: GetFreelancersWorkforceV2Request, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<FreelancersWorkforceListV2Resource> {
        const response = await this.getFreelancersWorkforceV2Raw(requestParameters, initOverrides);
        return response._data;
    }

}
